import { Markierung } from '@/domain/mitarbeiter/features/rotationsplan/entities/Markierung';
import { KalenderStationByArbeitsbereich } from '@/domain/mitarbeiter/features/rotationsplan/features/Kalender/entities/KalenderStation';
import { getColorsForMarkierung } from '@/domain/mitarbeiter/features/rotationsplan/utils/getColorForMarkierung';

export class KalenderArbeitsbereich {
  constructor({
    markierung,
    name,
    stationen,
    id,
    standortId,
  }: {
    markierung: Markierung;
    name: string;
    stationen?: KalenderStationByArbeitsbereich[];
    id: string;
    standortId: string;
  }) {
    this.markierung = markierung;
    this.name = name;
    this.stationen = stationen;
    this.id = id;
    this.standortId = standortId;
  }

  id: string;
  standortId: string;
  markierung: Markierung;
  name: string;
  stationen?: KalenderStationByArbeitsbereich[];

  getFillColor(): string {
    return getColorsForMarkierung(this.markierung).light;
  }

  getBorderColor(): string {
    return getColorsForMarkierung(this.markierung).base;
  }
}
